module.exports = __webpack_public_path__ + "img/钢铁在线监测预警全模块.dee4d880.png";